/*NB этот файл не обрабатывается через babel*/
angular.module('templates', []);
angular.module('kaiko.services', []);
angular.module('kaiko.controllers', []);
angular.module('kaiko.directives', []);
angular.module('kaiko.call', []);
angular.module('kaiko.push', []);
angular.module('kaiko.files', []);

angular.module('kaiko.filters', []);
angular.module('kaiko.users-presence', []);
angular.module('kaiko.scroll', []);

//TODO remove ttClick
(($)=> {
  $.fn.ttClick = function(selector, fn) {

    if (!selector && !fn) {
      //let down = jQuery.Event('pointerdown');
      //let up = jQuery.Event('pointerup');

      this.trigger('pointerdown');
      this.trigger('pointerup'  );
      return;
    }

    let clickStarted;
    const prevCoord = {}
    const MAX_CLICK_DIFF = 5;

    function OnPointerDown(e) {
      clickStarted = true;
      prevCoord.x = e.originalEvent && e.originalEvent.screenX || 0;
      prevCoord.y = e.originalEvent && e.originalEvent.screenY || 0;
    }

    function OnPointerUp(e) {
      if (!clickStarted)
        return;

      if (Math.abs(prevCoord.x - (e.originalEvent && e.originalEvent.screenX || 0)) > MAX_CLICK_DIFF) return;
      if (Math.abs(prevCoord.y - (e.originalEvent && e.originalEvent.screenY || 0)) > MAX_CLICK_DIFF) return;


      fn.apply(this, [e]);
      clickStarted = false;
    }


    this.on('click', selector, (e)=> window.UtStatic.prevDefStopProp(e));

    this.on('pointerdown', selector, OnPointerDown);
    this.on('pointerup',   selector, OnPointerUp);


    return this;
  };
})(jQuery);
